import { Grid } from '@material-ui/core';
import React from 'react';
import { Loader } from '../../../../../components/Loader';
import { NotFound } from '../../../../../components/NotFound';
import { FlexContainer } from '../../../../../layout/Flex';
import { Page } from '../../../../../layout/Page';
import { ImpersonationLink } from '../../../../components/ImpersonationLink';
import {
  AnchoredSections,
  AnchorLinks,
  ISection
} from '../../../../layout/AnchoredSection';
import { TopNav } from '../../../../layout/TopNav';
import { useOrgById } from '../../../../services/orgs';
import { OrgNavHeader } from '../../components/OrgNavHeader';
import { OrgTierChip } from '../../components/OrgTierChip';
import { Actions } from './components/Actions';
import { AdminUserInvitations } from './components/AdminUserInvitations';
import { AdminUsers } from './components/AdminUsers';
import { Dispatch } from './components/Dispatch';
import { Features } from './components/Features';
import { General } from './components/General';
import { IntegrationSupport } from './components/IntegrationSupport';
import { RepairInvestigate } from './components/RepairInvestigate';
import { Templates } from './components/Templates';
import { Users } from './components/Users';

type Props = {
  orgId: string;
};

export const PageOrgDetails: React.FC<Props> = ({ orgId }) => {
  const [org, loading] = useOrgById(orgId);

  if (loading) {
    return <Loader />;
  }
  if (!org) {
    return <NotFound />;
  }

  const SECTIONS: ISection[] = [
    { anchor: 'general', label: 'General', el: <General org={org} /> },
    {
      anchor: 'adminUsers',
      label: 'Admin Users',
      el: <AdminUsers org={org} />
    },
    {
      anchor: 'adminUsers',
      label: 'Invitations',
      el: <AdminUserInvitations org={org} />
    },
    { anchor: 'users', label: 'Users', el: <Users org={org} /> },
    { anchor: 'templates', label: 'Templates', el: <Templates org={org} /> },
    { anchor: 'features', label: 'Features', el: <Features org={org} /> },
    { anchor: 'actions', label: 'Actions', el: <Actions org={org} /> },
    { anchor: 'dispatch', label: 'Dispatch', el: <Dispatch org={org} /> },
    {
      anchor: 'integrationSupport',
      label: 'Integration support',
      el: <IntegrationSupport org={org} />
    },
    {
      anchor: 'repairInvestigate',
      label: 'Repair/investigate',
      el: <RepairInvestigate org={org} />
    }
  ];

  return (
    <>
      <TopNav>
        <Grid container alignItems="center" justify="space-between">
          <Grid item>
            <OrgNavHeader
              parts={[
                <FlexContainer>
                  {org.data.name}
                  <OrgTierChip tier={org.data.tier} />
                </FlexContainer>
              ]}
            />
          </Grid>
          <Grid item>
            <ImpersonationLink orgId={orgId} />
          </Grid>
        </Grid>
        <AnchorLinks sections={SECTIONS} offset={120} />
      </TopNav>
      <Page style={{ marginTop: 100 }} width={1500}>
        <AnchoredSections sections={SECTIONS} />
      </Page>
    </>
  );
};
